import React from "react";
import Button from "../Button/Button";
import styles from "./AdminPricingCard.module.scss";

const AdminPricingCard = ({
  title,
  price,
  credits,
  buttonText,
  popular,
  icon,
  onClick,
  buttonClass,
  GstText,
}) => {
  const isStringIcon = typeof icon === "string";

  return (
    <div
      className={`${styles["admin-pricing-card"]} ${popular ? styles["admin-pricing-card--popular"] : ""}`}
    >
      {popular && (
        <div className={styles["admin-pricing-card__badge"]}>Most Popular</div>
      )}

      <div className={styles["admin-pricing-card__icon"]} aria-hidden="true">
        {isStringIcon ? <img src={icon} alt="" /> : icon}
      </div>

      <h3 className={styles["admin-pricing-card__title"]}>{title}</h3>

      <div className={styles["admin-pricing-card__price-box"]}>
        <h2 className={styles["admin-pricing-card__price"]}>{price}</h2>
        <p className={styles["admin-pricing-card__credits"]}>{credits}</p>
      </div>

      {GstText && (
        <p className={styles["admin-pricing-card__gst"]}>{GstText}</p>
      )}

      <div className={styles["admin-pricing-card__btn-wrapper"]}>
        <Button
          text={buttonText}
          onClick={onClick}
          className={buttonClass ? buttonClass : "btn_primary"}
        />
      </div>
    </div>
  );
};

export default AdminPricingCard;
